import React from "react";
import { components } from "react-select";
import { TypeIcon } from "../../Constants/assets";

const SingleValue = ({ children, data, ...props }) => {
  return (
    <components.SingleValue {...props}>
      <div className="feed-type-selected-value">
        {TypeIcon[data.value]&&<img src={TypeIcon[data.value]} alt="type" />}
        {data.label}
      </div>
    </components.SingleValue>
  );
};

export default SingleValue;



// WEBPACK FOOTER //
// ./src/components/ContentUpload/SingleValue.js